export const sharedNav = `
  <nav class="normalMenu computer">
  </nav>
`

export const sharedMobileNav = `
<div class="mobileMenu mobile">
</div>
`

export const sharedTags = `
<script>var $root = "/"</script>
<link href="//netdna.bootstrapcdn.com/twitter-bootstrap/2.3.2/css/bootstrap-combined.no-icons.min.css" rel="stylesheet">
<link href="//netdna.bootstrapcdn.com/font-awesome/3.2.1/css/font-awesome.css" rel="stylesheet">
`
